import { pki, pki as NodeForgePki } from 'node-forge';

export type FileType = 'CA_CERTIFICATE' | 'USER_CERTIFICATE' | 'PRIVATE_KEY';

export const CERTIFICATE_FORMAT_HINT = 'PEM encoded X.509 certificate, usually a .pem or .crt file.';

export const PRIVATE_KEY_FORMAT_HINT = 'PEM encoded private key, usually a .pem or .key file.';

export const INVALID_CERTIFICATE_MESSAGE = `Invalid certificate. Upload a ${CERTIFICATE_FORMAT_HINT}`;

export const INVALID_PRIVATE_KEY_MESSAGE =
  'Invalid private key. Make sure the file is a PEM encoded private key, including its BEGIN and END lines.';

export function download(filename: string, text: string) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export function encodeBase64(value: string) {
  return btoa(unescape(encodeURIComponent(value)));
}

export function decodeBase64(value: string) {
  return atob(btoa(unescape(encodeURIComponent(value))));
}

export function readFileAsString(fileInput: Blob, fileType: FileType) {
  if (fileInput === undefined) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      if (event?.target?.result === undefined) {
        return;
      }

      if (fileType === 'CA_CERTIFICATE' || fileType === 'USER_CERTIFICATE') {
        verifyCertificateFormat(event.target.result as string)? resolve(encodeBase64(event.target.result as string)): reject(INVALID_CERTIFICATE_MESSAGE);
      } else if (fileType === 'PRIVATE_KEY') {
        verifyPrivateKey(event.target.result as string)? resolve(encodeBase64(event.target.result as string)): reject(INVALID_PRIVATE_KEY_MESSAGE);
      } else {
        reject('Invalid file type');
      }
    };
    reader.onerror = reject;
    reader.readAsText(fileInput);
  });
}


function verifyCertificateFormat(certContent: string): boolean {
  try {
    // Parse the certificate
    const certificate: NodeForgePki.Certificate = pki.certificateFromPem(certContent);
    // If parsing is successful, the certificate format is valid
    return true; // The certificate is valid
  } catch (error) {
    console.error('Error verifying certificate:', error);
    return false; // The certificate is invalid
  }
}
function verifyPrivateKey(privateKeyContent: string): boolean {
  // Accepts any PEM key label, such as "RSA PRIVATE KEY", "PRIVATE KEY",
  // "ENCRYPTED PRIVATE KEY" and "EC PRIVATE KEY", by looking for a BEGIN line
  // followed by an END line that both mention "private" and "key".
  const lines = privateKeyContent.toLowerCase().split(/\r?\n/);
  const isMarkerLine = (line: string, marker: string) =>
    [marker, 'private', 'key'].every((word) => line.includes(word));
  const beginIndex = lines.findIndex((line) => isMarkerLine(line, 'begin'));
  return beginIndex !== -1 && lines.slice(beginIndex + 1).some((line) => isMarkerLine(line, 'end'));
}

export function isIpAddress(ipaddress: string) {
  if (
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      ipaddress
    )
  ) {
    return true;
  }
  return false;
}
